<script>
    import Spinner from "../../../../components/spinner/Spinner.svelte";
    import FormErrors from "../../../../components/forms/FormErrors.svelte";
    import {apiFetch, apiPost} from '../../../../apiFetch';
    import {createForm, Field} from "svelte-forms-lib";
    import {
        Button,
        Form,
        FormGroup,
        Input,
        Label,
    } from 'sveltestrap';
    import {goto} from "@sveltech/routify/runtime";
    import {_} from 'svelte-i18n';

    let submitting = false;
    let formError = null;
    export let eventId;

    const {form, handleChange, handleSubmit} = createForm({
        initialValues: {
            description: '',
        },
        onSubmit: values => {
            submitting = true;

            apiPost('/campaigns/', values)
                    .then((result) => {
                        if (result.status !== 200) {
                            formError = result.errors;
                        } else {

                        }
                        submitting = false;
                    })
                    .catch((error) => {
                        alert(error);
                        submitting = false;
                    });
        }
    });

    $goto('/app/campaigns/goals');

</script>

<div class="container">
    <h2>{$_('page.campaign.new.title')}</h2>

    <div>
        <p>{$_('page.campaign.new.intro')}</p>
    </div>

    {#await apiFetch('/organizations/events/' + eventId)}
        <Spinner/>
    {:then data}
        <hr/>
        Event: {data.event.name}
        <hr/>

        {#if submitting}
            <Spinner/>
        {/if}
        {#if formError}
            <FormErrors errors={formError}/>
        {/if}
        <Form on:submit={handleSubmit} class="content">
            <FormGroup>
                <Label for="capacity">Capacity</Label>
                <Input
                        id="capacity"
                        name="capacity"
                        type="number"
                        on:change={handleChange}
                        bind:value={$form.capacity}
                />
                <small class="form-text text-muted">{$_('page.campaign.new.help.capacity')}</small>
            </FormGroup>

            <FormGroup>
                <Label for="desired">Desired amount of visitors</Label>
                <Input
                        id="desired"
                        name="desired"
                        type="number"
                        on:change={handleChange}
                        bind:value={$form.desired}
                />
                <small class="form-text text-muted">{$_('page.campaign.new.help.desired')}</small>
            </FormGroup>

            <FormGroup>
                <Button type="submit" color="primary">{$_('page.campaign.new.calculateCampaign')}</Button>
            </FormGroup>

        </Form>
    {:catch error}
        {@debug error}
        <p>An error occurred!</p>
    {/await}
</div>